'use client';

import { IconButton } from '../button';
import { BaseTopNavigation } from '../topNavigation';

import { Sidebar, SidebarContent, useSidebar } from './sidebar';

const AppSidebar = () => {
  const { toggleSidebar } = useSidebar();

  return (
    <Sidebar side="right">
      <SidebarContent>
        <BaseTopNavigation className="absolute" rightAction={<IconButton onClick={toggleSidebar} iconType="close" />} />
      </SidebarContent>
    </Sidebar>
  );
};

export default AppSidebar;
